/**
 * Canonical Studio project model. See:
 * - 5-6
 *
 * No DOM/React/Angular/target import here — this package is framework-neutral (, ).
 */
export const STUDIO_VERSION = 1;
/**
 * Every kind here must have a Contract v2 equivalent in studio-contract's
 * FIELD_KIND_MAP — the value type drives validator compatibility, the kind only
 * drives which control renders.
 */
export const STUDIO_FIELD_KINDS = [
    "text",
    "textarea",
    "email",
    "password",
    "number",
    "slider",
    "checkbox",
    "toggle",
    "select",
    "radio",
    "segmented",
    "multiselect",
    "date",
    "time",
];
/** Depth cap for nested layout, matching Contract v2's own guard. */
export const STUDIO_LAYOUT_MAX_DEPTH = 6;
/**
 * How deep a schema may nest, as a judgement about what an author can work with.
 *
 * Declared here because two packages hold an opinion about it and they were not the same one: the
 * editor refuses to *place* a node past this, so nothing built in a session goes deeper, while the
 * loader accepted any depth from a file and said nothing. A loader silently accepting what its own
 * editor refuses to build is the shape of a project nobody can then edit.
 *
 * The editor reads this rather than declaring its own, so the two cannot drift apart again.
 */
export const STUDIO_SCHEMA_MAX_DEPTH = 32;
/** Names that would collide with object-prototype internals or JS reserved identifiers. */
export const RESERVED_NAMES = new Set([
    "__proto__",
    "constructor",
    "prototype",
]);
